import React from "react";
import PageView from "./page_view";
import {Container} from "../core/components";

export default function Index({match}) {
    return <Container key={"ljsf"}>
        <PageView key={"dahoam"} slot={"dahoam"+window.location.pathname}/>
    </Container>
}
